export const allUnchecked = (style) => {
  return (
    style.price_filters.every((filter) => !filter.active) &&
    style.region_filters.every((filter) => !filter.active)
  )
}

export const isValidEmail = (email) => {
  const re = /\S+@\S+\.\S+/
  return re.test(email)
}
